import React, { useEffect, useState } from 'react'
import usePersistedFilters from '../../hooks/usePersistedFilters'
import PageHeader from '../../shared/PageHeader'
import {
  FaArrowCircleLeft,
  FaArrowCircleRight,
  FaFileExcel,
  FaFilePdf,
  FaPrint,
} from 'react-icons/fa'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import useFetchData from '../../hooks/UseFetchData'
import moment from 'moment'
import DoctorRepFilter from '../../components/his/doctorWiseReport/DoctorRepFilter'
import CustomButton from '../../shared/CustomButton'
import DoctorReportTable from '../../components/his/doctorWiseReport/DoctorReportTable'
import {
  exportDocRepToExcel,
  exportDocRepToPDF,
  transformReportData,
} from '../../constants/DocRepConstants'
import { useSelector } from 'react-redux'

import { validateOneMonthRange } from '../../utils/dateRangeValidation'

function DoctorWiseReport() {
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()
  const { data, loading, executeFetch } = useFetchData()
  const auth = useSelector(state => state.auth)
  const { filters: payload, setFilters: setPayload } = usePersistedFilters(
    'doctor_wise_report',
    {
      start_date: moment().format('YYYY-MM-DD'),
      end_date: moment().format('YYYY-MM-DD'),
      practitioner_id: '',
      department_id: '',
    }
  )
  const fetchInitialData = async (payloadData = payload) => {
    if (!validateOneMonthRange(payloadData.start_date, payloadData.end_date, t)) return
    await executeFetch('POST', '/v3/invoices/practitionerBillingHistory', {
      ...payloadData,
      start_date: moment(payloadData.start_date).format('YYYY-MM-DD'),
      end_date: moment(payloadData.end_date).format('YYYY-MM-DD'),
    })
  }
  // useEffect(() => {
  //   fetchInitialData()
  // }, [])
  return (
    <div className="main-page-container !overflow-y-auto scrollbar">
      <PageHeader
        title={t('Doctor Wise Report')}
        iconSize={20}
        Icon={i18n.language == 'en' ? FaArrowCircleLeft : FaArrowCircleRight}
        onIconClick={() => navigate(-1)}
      ></PageHeader>
      <div className="mt-2 w-full h-full">
        <div className="flex items-center justify-between">
          <DoctorRepFilter
            setPayloadData={setPayload}
            payloadData={payload}
            filterData={fetchInitialData}
            loading={loading}
          />

          <div className="flex items-start gap-2 mb-4 col-span-12 md:col-span-4 lg:col-span-4 xl:col-span-3">
            <CustomButton
              //label={t('Export to Excel')}
              title={t('Export to Excel')}
              buttonType="success"
              icon={FaFileExcel}
              className="w-fit h-[35px]"
              onClick={() => {
                exportDocRepToExcel(transformReportData(data?.daily_summary), t)
              }}
            />
            <CustomButton
              //label={t('Export to PDF')}
              title={t('Export to PDF')}
              buttonType="danger"
              icon={FaFilePdf}
              className="w-fit h-[35px]"
              onClick={() => {
                exportDocRepToPDF(
                  transformReportData(data?.daily_summary),
                  t,
                  {
                    ...payload,
                    business_en: auth?.buisnessInfo?.name_en,
                    business_ar: auth?.buisnessInfo?.name_ar,
                    address: auth?.buisnessInfo?.address,
                    logo: auth?.buisnessInfo?.logo,
                  }
                )
              }}
            />
          </div>
        </div>
        <DoctorReportTable
          data={data}
          payload={payload}
          setPayload={setPayload}
          loading={loading}
          fetchInitialData={fetchInitialData}
        />
      </div>
    </div>
  )
}

export default DoctorWiseReport
